import { isFunction, assign } from '../../core/utils';
function passRequestInterceptor(config) {
    var passParamsGenerator = config.passParamsGenerator;
    if (isFunction(passParamsGenerator)) {
        var passParams = passParamsGenerator(config);
        config.params = assign({}, passParams, config.params || {});
    }
    return config;
}
export default passRequestInterceptor;
//# sourceMappingURL=index.js.map